import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'Vee Lite';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
/** Use `'/help'` if support page is mounted at `/help/support-help`; `''` keeps `/support-help`. */
export const HELP_PREFIX_PATH = '';
export const SUPPORT_HELP_PUBLIC_PATH = `${HELP_PREFIX_PATH}/support-help`.replace(/\/+/g, '/');
export { PRIVACY_PUBLIC_PATH, PRIVACY_PUBLIC_ALIAS_PATH, TERMS_PUBLIC_PATH } from 'constants/LegalConstant';
export const REDIRECT_URL_KEY = 'redirect'
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/home`;
export const UNAUTHENTICATED_ENTRY = '/login'

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	blankLayout: false
};
